import { render, staticRenderFns } from "./club-members-overview.vue?vue&type=template&id=2a15c4b1"
import script from "./club-members-overview.vue?vue&type=script&lang=js"
export * from "./club-members-overview.vue?vue&type=script&lang=js"
import style0 from "./club-members-overview.vue?vue&type=style&index=0&id=2a15c4b1&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/projects/subsapp-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a15c4b1')) {
      api.createRecord('2a15c4b1', component.options)
    } else {
      api.reload('2a15c4b1', component.options)
    }
    module.hot.accept("./club-members-overview.vue?vue&type=template&id=2a15c4b1", function () {
      api.rerender('2a15c4b1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/club-members/club-members-overview.vue"
export default component.exports